import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableFraudPreventionMessage',
  initialState: false,
  reducers: {
    setEnableFraudPreventionMessage(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableFraudPreventionMessage } = slice.actions;

export default slice.reducer;
